export enum Quarter {
  FIRST_QUARTER = 'Q1',
  SECOND_QUARTER = 'Q2',
  THIRD_QUARTER = 'Q3',
  FOURTH_QUARTER = 'Q4',
}
